import styled from 'styled-components';
import { Form } from 'formik';
import { rgba } from 'polished';

// CONSTANTS
import { WHITE, BLACK } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Wrapper = styled.div`
  margin-bottom: 50px;

  .notify-me-section {
    &__form {
      display: flex;
      align-items: flex-start;
    }

    &__button {
      margin-top: 7px;
      min-width: 190px;
      flex-shrink: 0;

      ${breakpoints.down('xs')} {
        min-width: auto;
      }
    }
  }

  .MuiFormControl-root {
    padding-right: 20px;
  }
`;

export const Container = styled.div`
  position: relative;
  padding: 32px 24px;
  background-color: ${WHITE};
  border-radius: 8px;
  box-shadow: 0 2px 12.9px 0 ${rgba(BLACK, 0.07)};
`;

export const FormStyled = styled(Form)`
  margin-top: 25px;
`;

export default Wrapper;
